export default "__VITE_ASSET__Cq36n9BP__"